import { useState } from 'react';

/* Utils. */
import classnames from 'classnames';

/* Material UI */
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import InfoIcon from '@material-ui/icons/Info';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

/* Styles */
import css from './nibCardItem.module.sass';

const NibCardItem = ({
  name,
  text = 'Some Text',
  children,
  btns = ['add', 'hide', 'info'],
  isHideActive,
  newUI,
  onAdd = () => {},
  onHide = () => {},
  onInfo = () => {},
}) => {
  let [isHide, setHide] = useState(isHideActive);
  let [isInfo, setInfo] = useState(false);

  const localOnHide = () => {
    setHide(!isHide);
    onHide();
  };

  const localOnInfo = () => {
    setInfo(!isInfo);
    onInfo();
  };

  return (
    <div className={classnames(css.wrap, 'ui-card-item')}>
      {(name || !!btns?.length) && (
        <div className={classnames(css.header, 'ui-card-item-header')}>
          {name && <strong>{name}</strong>}
          {!!btns?.length && (
            <ul className={classnames(css.header, 'ui-card-item-btns')}>
              {btns.includes('add') && (
                <li className={classnames('ui-card-item-btns-add')}>
                  <IconButton onClick={onAdd}>
                    <AddCircleOutlinedIcon />
                  </IconButton>
                </li>
              )}
              {btns.includes('hide') && (
                <li
                  className={classnames(
                    !isHide ? css.active : '',
                    newUI ? 'ui-card-item-btns-hide-new' : 'ui-card-item-btns-hide',
                  )}
                >
                  <IconButton onClick={localOnHide}>{!isHide ? <VisibilityIcon /> : <VisibilityOffIcon />}</IconButton>
                </li>
              )}
              {btns.includes('info') && (
                <li
                  className={classnames(
                    isInfo ? css.active : '',
                    isInfo ? 'ui-card-item-btns-active' : '',
                    'ui-card-item-btns-info',
                  )}
                >
                  <IconButton onClick={localOnInfo}>
                    <InfoIcon />
                  </IconButton>
                </li>
              )}
            </ul>
          )}
        </div>
      )}

      {children ? <div className={classnames(css.content, 'ui-card-item-content')}>{children}</div> : <p>text</p>}
    </div>
  );
};

export default NibCardItem;
